module.exports = __webpack_public_path__ + "static/img/rotate13.933f2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate13.png
// module id = Xt4q
// module chunks = 1